const commisRouteUpdateAction = () => ({});

export { commisRouteUpdateAction };



// WEBPACK FOOTER //
// ./src/action.js